import {
  Box,
  Divider,
  Grid,
  GridItem,
  Link,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Text,
  VStack,
} from '@chakra-ui/react';
import { MitreMappings } from '../../../../shared/generated/graphql';
import { FC, useMemo } from 'react';

export const MitreTechniquesGridTruncated: FC<MitreMappings> = ({
  tactics,
}) => {
  const allTechniques = useMemo(() => {
    return (
      tactics
        ?.flatMap((tactic) => tactic?.techniques || [])
        .filter((tech): tech is NonNullable<typeof tech> =>
          Boolean(tech?.name && tech?.link),
        ) || []
    );
  }, [tactics]);

  const remaining = allTechniques.slice(1);

  return allTechniques.length > 0 ? (
    <VStack alignItems="start">
      <Grid
        templateColumns="auto 1fr auto"
        columnGap={2}
        width="100%"
        key={allTechniques[0].name}
      >
        <GridItem>
          <Text color="text.secondary" whiteSpace="nowrap">
            {allTechniques[0].tag?.split('.')[1].toLocaleUpperCase()}
          </Text>
        </GridItem>
        <GridItem overflow="hidden" minW={0}>
          <Link
            isExternal
            href={allTechniques[0].link ?? '#'}
            textDecoration="none"
            color="text.link"
            display="block"
            overflow="hidden"
            whiteSpace="nowrap"
            textOverflow="ellipsis"
          >
            {allTechniques[0].name}
          </Link>
        </GridItem>
        {remaining.length > 0 && (
          <GridItem>
            <Popover placement="bottom" isLazy>
              <PopoverTrigger>
                <Box position="relative">
                  <Link color="text.link" textDecoration="none">
                    + {remaining.length}
                  </Link>
                </Box>
              </PopoverTrigger>
              <PopoverContent zIndex="popover">
                <PopoverArrow />
                <PopoverBody p={3}>
                  <VStack alignItems="start" spacing={2}>
                    <Text fontWeight={600}>MITRE ATT&CK Techniques</Text>
                    {!!tactics?.length &&
                      tactics.flatMap((mitreMapping) =>
                        mitreMapping?.techniques?.map((mitreTechnique) =>
                          mitreTechnique?.name && mitreTechnique?.link ? (
                            <Box key={mitreTechnique.name} w="100%">
                              <Grid
                                templateColumns="auto 1fr"
                                columnGap={2}
                                alignItems="start"
                                mb={2}
                              >
                                <GridItem>
                                  <Text
                                    color="text.secondary"
                                    whiteSpace="nowrap"
                                  >
                                    {mitreTechnique.tag
                                      ?.split('.')[1]
                                      .toLocaleUpperCase()}
                                  </Text>
                                </GridItem>
                                <GridItem overflow="hidden" minW={0}>
                                  <Link
                                    isExternal
                                    color="text.link"
                                    textDecoration="none"
                                    href={mitreTechnique.link}
                                    display="block"
                                    overflow="hidden"
                                    whiteSpace="nowrap"
                                    textOverflow="ellipsis"
                                  >
                                    {mitreTechnique.name}
                                  </Link>
                                </GridItem>
                              </Grid>
                              <Divider />
                            </Box>
                          ) : null,
                        ),
                      )}
                  </VStack>
                </PopoverBody>
              </PopoverContent>
            </Popover>
          </GridItem>
        )}
      </Grid>
    </VStack>
  ) : (
    '-'
  );
};
